/**
 * Calendar-day buckets for workspace lists (home project picker).
 * Uses the viewer's local calendar (Date in browser).
 */

export type ProjectRecencyBucket = "today" | "yesterday" | "earlier";

export function bucketProjectUpdatedAt(
  updatedAtIso: string | undefined,
  now: Date = new Date(),
): ProjectRecencyBucket {
  if (!updatedAtIso || updatedAtIso.trim().length === 0) return "earlier";
  const d = new Date(updatedAtIso);
  if (Number.isNaN(d.getTime())) return "earlier";

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);

  if (d >= startOfToday) return "today";
  if (d >= startOfYesterday) return "yesterday";
  return "earlier";
}

export const PROJECT_BUCKET_LABEL: Record<ProjectRecencyBucket, string> = {
  today: "Today",
  yesterday: "Yesterday",
  earlier: "Earlier",
};
